import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { parseQueryParams } from 'pricing-pages-ui-components/utils/queryParamUtils';
export const usePreserveQueryParams = () => {
  const location = useLocation();
  const createToWithQueryParams = useMemo(() => {
    return pathname => {
      const currentQueryParams = parseQueryParams(location.search);
      const searchParams = new URLSearchParams();
      Object.entries(currentQueryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (Array.isArray(value)) {
            value.forEach(v => searchParams.append(key, v));
          } else {
            searchParams.set(key, value);
          }
        }
      });
      const search = searchParams.toString();
      return {
        pathname,
        search: search ? `?${search}` : ''
      };
    };
  }, [location.search]);
  return createToWithQueryParams;
};